

import styles from './index.module.scss'
import { useNavigate } from "react-router-dom"
import { Button, Dropdown } from 'antd';
import Iconfont from '@utils/Iconfont';
import Utils from '@utils/utils';
import { BATCH_IMAGES_TYPE } from '@utils/CONST'
import { DownOutlined } from '@ant-design/icons';
import { useEffect } from 'react';
const notUploadUrl = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/batchProduceImages/notuploaded.png'


const GroupWrapLeft = (props) => {
    const navigate = useNavigate()
    const { item, projectType, refListModalRef, regenerateByTaskId, reEditClick } = props
    const items = {
        [BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH]: [
            { label: <p className={styles.Dropdown_p} ><span>肤质高清</span><span>{item[0]?.attr?.skinRefine == 1 ? '开' : '关'}</span></p>, key: 'taskDetail' },
            { label: <p className={styles.Dropdown_p} ><span>光影融合</span><span>{item[0]?.attr?.relight == 1 ? '开' : '关'}</span></p>, key: 'taskDetail' }
        ],
        [BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH]: [
            { label: <p className={styles.Dropdown_p} ><span>肤质高清</span><span>{item[0]?.attr?.skinRefine == 1 ? '开' : '关'}</span></p>, key: 'taskDetail' },
            { label: <p className={styles.Dropdown_p} ><span>光影融合</span><span>{item[0]?.attr?.relight == 1 ? '开' : '关'}</span></p>, key: 'taskDetail' },
            { label: <p className={styles.Dropdown_p} ><span>场景相似度</span><span>{item[0]?.attr?.customBkgMode == 'free' ? '变化更多' : '场景不变'}</span></p>, key: 'taskDetail' },
            { label: <p className={styles.Dropdown_p} ><span>生成比例</span><span>{item[0]?.attr?.resolutionAlign == 'input' ? '输入图比例' : '参考图比例'}</span></p>, key: 'taskDetail' }
        ],
        [BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH]: [
            { label: <p className={styles.Dropdown_p} ><span>商品颜色</span><span>{item[0]?.attr?.commodityColor?.[0]?.title} 共{item[0]?.attr?.commodityColor?.length}种</span></p>, key: 'taskDetail' },
            { label: <p className={styles.Dropdown_p} ><span>类目</span><span>{item[0]?.attr?.commodityCategory?.title}</span></p>, key: 'taskDetail' },
            { label: <p className={styles.Dropdown_p} ><span>模板</span><span>{item[0]?.attr?.commodityTemplate?.title}</span></p>, key: 'taskDetail' },
        ],
    }

    return (
        <div className={styles.groupWrapLeft} style={{ width: projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ? '220px' : '420px' }}>
            <p className={styles.groupWrapLeftItemTitle}>
                {
                    (projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
                        projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ||
                        projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) &&
                    <Dropdown menu={{ items: items[projectType] || [] }}>
                        <a onClick={e => e.preventDefault()}>
                            <>
                                任务详情 <DownOutlined />
                            </>
                        </a>
                    </Dropdown>
                }

                {
                    projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ? <span>
                        {
                            item[0]?.attr?.mode == 'std' ?
                                <><Iconfont className={styles.Iconstd} type="icon-fastModeOutlined" /> 标准模式</> :
                                <><Iconfont className={styles.Iconhq} type="icon-qualityModeOutlined" /> 高质量模式</>
                        }
                    </span> : null
                }
                <span className={styles.taskSerial}>任务ID：{item[0]?.taskSerial}</span>
            </p>

            <div className={styles.groupWrapLeftItemWrap}>
                {
                    projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ?
                        <div
                            onClick={() => refListModalRef.current.open(item[0]?.inputImages)}
                            className={`${styles.groupWrapLeftItem} ${styles.groupWrapLeftItem2}`} >
                            <p>详情页图片</p>
                            {
                                item[0]?.inputImages?.slice(0, 3)?.map((ref, index) => (
                                    <div key={index} className={`${styles.groupWrapLeftItemImg} ${index == 2 ? styles.groupWrapLeftItemImg_F : ''}`}>
                                        <img src={Utils.getImgThumbnail(ref?.url)} alt="" />
                                        {index == 2 && <div className={styles.groupWrapLeftItemImg_F_Text}>+{item[0]?.inputImages?.length}件</div>}
                                    </div>
                                ))
                            }
                        </div> :
                        <div className={styles.groupWrapLeftItem}>
                            <p>{projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? '商品图' :
                                projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? '主品图' :
                                    projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ? '输入图' :
                                        '模特图'}</p>
                            <div className={styles.groupWrapLeftItemImg}>
                                <img src={Utils.getImgThumbnail(item[0]?.inputImages?.filter(i => i.mainImage)[0]?.url)} alt="" />
                                {
                                    projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH && <p className={styles.imgNum}>数量{item[0]?.inputImages?.[0].num}</p>
                                }
                            </div>
                        </div>
                }
                {
                    (projectType === BATCH_IMAGES_TYPE.TRYON_BATCH) &&
                    <div className={styles.groupWrapLeftItem}>
                        <p>{item[0]?.inputImages?.filter(i => !i.mainImage)[0]?.url ? '搭配图' : '未传搭配图'}</p>
                        <div className={styles.groupWrapLeftItemImg}>
                            <img src={
                                item[0]?.inputImages?.filter(i => !i.mainImage)[0]?.url ?
                                    Utils.getImgThumbnail(item[0]?.inputImages?.filter(i => !i.mainImage)[0]?.url) :
                                    notUploadUrl} alt="" />
                        </div>
                    </div>
                }
                {
                    (projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ||
                        projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH) &&
                    <div className={styles.groupWrapLeftItem}>
                        <p>{item[0]?.attr?.person?.url ? item[0]?.attr?.person?.title?.split('-').pop() : '未传模特图'}</p>
                        <div className={styles.groupWrapLeftItemImg}>
                            <img src={item[0]?.attr?.person?.url ? Utils.getImgThumbnail(item[0]?.attr?.person?.url) : notUploadUrl} alt="" />
                        </div>
                    </div>
                }
                {
                    projectType == BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH && (
                        <div className={styles.groupWrapLeftItem}>
                            <p style={{ width: '128px' }}>同款不同色平铺图</p>
                            <div className={styles.groupWrapLeftItemImg} style={{ width: '128px' }}>
                                <img src={item[0]?.attr?.inputCloth} alt="" style={{ width: '128px' }} />
                            </div>
                        </div>
                    )
                }
                {
                    (projectType == BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH && item[0]?.attr?.matchCloth) && (
                        <div className={styles.groupWrapLeftItem}>
                            <p style={{ width: '128px' }}>搭配图</p>
                            <div className={styles.groupWrapLeftItemImg} style={{ width: '128px' }}>
                                <img src={item[0]?.attr?.matchCloth} alt="" style={{ width: '128px' }} />
                            </div>
                        </div>
                    )
                }
                {
                    projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH && <div
                        onClick={() => refListModalRef.current.open(item[0]?.attr?.refList)}
                        className={`${styles.groupWrapLeftItem} ${styles.groupWrapLeftItem2}`} >
                        <p>辅品图</p>
                        {
                            item[0]?.attr?.refList?.slice(0, 2)?.map((ref, index) => (
                                <div key={index} className={`${styles.groupWrapLeftItemImg} ${index == 1 ? styles.groupWrapLeftItemImg_F : ''}`}>
                                    <img src={Utils.getImgThumbnail(ref?.url)} alt="" />
                                    {index == 1 && <div className={styles.groupWrapLeftItemImg_F_Text}>+{item[0]?.attr?.refList?.length}件</div>}
                                    {index != 1 && <p className={styles.imgNum}>数量{ref.num}</p>}
                                </div>
                            ))
                        }
                    </div>
                }
                {
                    (projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) && <div className={styles.groupWrapLeftItem}>
                        <p>{item[0]?.attr?.background?.url ? item[0]?.attr?.background?.title : '未传背景图'}</p>
                        <div className={styles.groupWrapLeftItemImg}>
                            <img src={item[0]?.attr?.background?.url ? Utils.getImgThumbnail(item[0]?.attr?.background?.url) : notUploadUrl} alt="" />
                        </div>
                    </div>
                }
                {
                    (projectType == BATCH_IMAGES_TYPE.TRYON_BATCH) && <div className={styles.groupWrapLeftItem}>
                        <p>{item[0]?.attr?.pose?.url ? '姿势图' : '未传姿势图'}</p>
                        <div className={styles.groupWrapLeftItemImg}>
                            <img src={item[0]?.attr?.pose?.url ? Utils.getImgThumbnail(item[0]?.attr?.pose?.url) : notUploadUrl} alt="" />
                        </div>
                    </div>
                }
            </div>
            {
                !item[0]?.orgData && <div className={styles.groupWrapBtns}>
                    {
                        projectType != BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH &&
                        <Button style={{ width: 200, height: 32, marginRight: 12 }} onClick={() => reEditClick(item[0]?.projectId, item[0]?.skuId, item[0]?.taskId)}>重新编辑</Button>
                    }
                    {
                        (projectType != BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH &&
                            projectType != BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) &&
                        <Button style={{ width: 200, height: 32 }} onClick={() => regenerateByTaskId(item[0]?.taskId)}>再次生成</Button>
                    }
                </div>
            }
        </div>
    )
}

export default GroupWrapLeft